import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `byteLength` property of an object.
export default shallowProperty('byteLength');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/_getByteLength.js
// module id = 139
// module chunks = 0 1